import styles from './MCCAItem.module.css'
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import MCCAUnit from "./MCCAUnit";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";

interface IMCCAItemProps
{
    onClose: ()=>void
    ctn:string
    tmpCtn:string
    orderId:string


}
interface IFlexItem{
    name:string
    productOfferingId:number
    type:string
}

interface IMCCAData
{
    orderId:string

    login:string
    tarifId:number
    flexList: number[]

    city?:string
    address?:string
    mode:number
    gender: string
    noContact?:boolean


    addressMode:number //0- из заказа 1- из запроса 2-сгенерировать из города


}


export default function MCCAItem({tmpCtn,ctn,onClose,orderId}:IMCCAItemProps){

    const refState = useRef<ErrorLineItemRef>(null)


    const [addressMode, setAddressMode] = useState(0)

    const flexListData = useRef()
    const [ldrFlexList,rsFlexList,exFlexList] = useApiQuery("/bio/app/megafon/flex/list","post",flexListData);
    const [flexList, setFlexList] = useState<IFlexItem[]>([])

    const [gender, setGender] = useState("M")

    const [noContact, setNoContact] = useState(false)



    const mccaRunData = useRef<IMCCAData>()
    const [ldrMccaRun,rsMccaRun,exMccaRun] = useApiQuery("/bio/app/megafon/mcca/make","post",mccaRunData);


    const [flexAp, setFlexAp] = useState<IFlexItem[]>([])
    const [ap, setAp] = useState(-1)

    const [flexPacket, setFlexPacket] = useState<IFlexItem[]>([])
    const [packet, setPacket] = useState(-1)


    const [flexSms, setFlexSms] = useState<IFlexItem[]>([])
    const [sms, setSms] = useState(-1)


    const [flexNet, setFlexNet] = useState<IFlexItem[]>([])
    const [net, setNet] = useState(-1)

    const [flexTarif, setFlexTarif] = useState<IFlexItem[]>([])
    const [tarif, setTarif] = useState(-1)

    const [bundleTarif, setBundleTarif] = useState<IFlexItem[]>([])
    const [bundle, setBundle] = useState(-1)


    const [mccaData, setMccaData] = useState<IMCCAData>({
        city:"Новосибирск",
        flexList:[],
        login:"",
        tarifId:0,
        mode:0,
        addressMode:addressMode,
        orderId: orderId,
        gender: "M"
    })
    useEffect(()=>{
        loadFlexList()
        loadLocalStorage()
    },[flexListData])

    useEffect(()=>{
        console.log(flexListData)
        if(! flexList) return
        setFlexAp(flexList?.filter((item)=>item?.type === "AP"))
        setFlexPacket(flexList?.filter((item)=>item?.type === "MINUTE"))
        setFlexSms(flexList?.filter((item)=>item?.type === "SMS"))
        setFlexNet(flexList?.filter((item)=>item?.type === "NET"))
        setFlexTarif(flexList?.filter((item)=>item?.type === "TARIF"))
        setBundleTarif(flexList?.filter((item)=>item?.type === "BUNDLE"))
    },[flexList])



    useEffect(()=>{
        console.log("flexAp",flexAp)
    },[flexAp])

    useEffect(()=>{
        saveLocalStorage()

    },[mccaData])


    useEffect(()=>{
        if(bundle>0){
            setTarif(-1)
            setAp(-1)
            setNet(-1)
            setSms(-1)
            setPacket(-1)

        }
    },[bundle])

    useEffect(()=>{
        if(tarif>0 || packet>0 || sms>0 || ap>0 || net>0)setBundle(-1)
    },[tarif,packet,sms,net,ap])


    const loadFlexList = () =>{
        exFlexList().then((e)=>{
            if(e?.success){
                setFlexList(e?.payload)
                return
            }
            if(refState?.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" , true, 4000)
        })
    }


    const loadLocalStorage = ()=>{
        const x = localStorage.getItem("mccaLogin")
        if(x) setMccaData({...mccaData, login: x?.toString()?.trim()})

    }
    const saveLocalStorage = ()=>{
        if(mccaData?.login) {
            localStorage.setItem("mccaLogin",mccaData?.login)
        }


    }

    const buildBundle = () =>{
        const x = bundleTarif?.map((item,idx)=>{
            return(
                <div key={idx} className={"col-lg-3 col-md-3 col-6"}>
                    <MCCAUnit onClick={(id)=>setBundle(item?.productOfferingId === bundle ? -1 : id)} name={item?.name} id={item?.productOfferingId} selected={item?.productOfferingId === bundle}/>

                </div>
            )

        })
        return x
    }

    const buildTarif = () =>{
        const x = flexTarif?.map((item,idx)=>{
            return(
                <div key={idx} className={"col-lg-3 col-md-3 col-6"}>
                    <MCCAUnit onClick={(id)=>setTarif(item?.productOfferingId === tarif ? -1 : id)} name={item?.name} id={item?.productOfferingId} selected={item?.productOfferingId === tarif}/>

                </div>
            )

        })
        return x
    }

    const buildAp = () =>{
        const x = flexAp?.map((item,idx)=>{
            return(
                <div key={idx} className={"col-lg-3 col-md-3 col-6"}>
                    <MCCAUnit onClick={(id)=>setAp(item?.productOfferingId === ap ? -1 : id)} name={item?.name} id={item?.productOfferingId} selected={item?.productOfferingId === ap}/>

                </div>
            )

        })
        return x
    }
    const buildNet = () =>{
        const x = flexNet?.map((item,idx)=>{
            return(
                <div key={idx} className={"col-lg-3 col-md-3 col-6"}>
                    <MCCAUnit onClick={(id)=>setNet(item?.productOfferingId === net ? -1 : id)} name={item?.name} id={item?.productOfferingId} selected={item?.productOfferingId === net}/>

                </div>
            )

        })
        return x
    }
    const buildSms = () =>{
        const x = flexSms?.map((item,idx)=>{
            return(
                <div key={idx} className={"col-lg-3 col-md-3 col-6"}>
                    <MCCAUnit onClick={(id)=>setSms(item?.productOfferingId === sms ? -1 : id)} name={item?.name} id={item?.productOfferingId} selected={item?.productOfferingId === sms}/>

                </div>
            )

        })
        return x
    }
    const buildPacket = () =>{
        const x = flexPacket?.map((item,idx)=>{
            return(
                <div key={idx} className={"col-lg-3 col-md-3 col-6"}>
                    <MCCAUnit onClick={(id)=>setPacket(item?.productOfferingId === packet ? -1 : id)} name={item?.name} id={item?.productOfferingId} selected={item?.productOfferingId === packet}/>

                </div>
            )

        })
        return x
    }


    const buildGenderItem = ()=>{
        return(
            <div className={styles.gCont}>
                <div className={styles.gTitle}>Пол</div>
                <div className={styles.gLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={gender === "M"} onChange={()=>setGender("M")}/>
                    <div className={styles.adTitle}>М</div>
                </div>
                <div className={styles.gLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={gender === "F"} onChange={()=>setGender("F")}/>
                    <div className={styles.adTitle}>Ж</div>
                </div>
            </div>
        )
    }


    const handleMnp = () =>{
        if(! refState.current) return
        refState.current.clear()
        const x = new Array<number>()
        let xTarif = tarif
        if(bundle < 0 )
        {
            if(tarif < 0){
                refState.current.show("Не выбран тариф", true, 4000)
                return
            }
            if(!ctn || ctn?.length !== 10){
                refState.current.show("Переносимый номер не корректен", true, 4000)
                return
            }
            if(! tmpCtn || tmpCtn?.length !== 10){
                refState.current.show("Временный номер не корректен", true, 4000)
                return
            }
            if(ap > 0)x?.push(ap)
            if(sms > 0)x?.push(sms)
            if(packet > 0)x?.push(packet)
            if(net > 0)x?.push(net)
        } else xTarif = bundle


        if(addressMode === 1){
            if(!mccaData?.address || mccaData?.address?.length < 3){
                refState.current.show("Не указан адрес", true, 4000)
                return
            }
        }

        if(addressMode === 2){
            if(!mccaData?.city || mccaData?.city?.length < 3){
                refState.current.show("Не указан город", true, 4000)
                return
            }
        }


        mccaRunData.current = {
            city: mccaData?.city ? mccaData?.city : undefined,
            address: mccaData?.address ? mccaData?.address : undefined,
            orderId: orderId,
            addressMode: addressMode,
            mode: 10,
            login: mccaData?.login,
            tarifId: xTarif,
            flexList: x,
            gender: gender,
            noContact: noContact

        }

        exMccaRun().then((e)=>{
            if(e?.success){
                if(refState?.current)refState.current.show("Задача запущена" , false, 0)
                return
            }
            if(refState?.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" , true, 0)

        })




    }


    const handleNew = () =>{
        if(! refState.current) return
        refState.current.clear()

        const x = new Array<number>()

        let xTarif = tarif
        if(bundle < 0 )
        {
            if(tarif < 0){
                refState.current.show("Не выбран тариф", true, 4000)
                return
            }
            if(!ctn || ctn?.length !== 10){
                refState.current.show("Регистрируемый номер не корректен", true, 4000)
                return
            }
            if(ap > 0)x?.push(ap)
            if(sms > 0)x?.push(sms)
            if(packet > 0)x?.push(packet)
            if(net > 0)x?.push(net)
        } else xTarif = bundle



        if(addressMode === 1){
            if(!mccaData?.address || mccaData?.address?.length < 3){
                refState.current.show("Не указан адрес", true, 4000)
                return
            }
        }

        if(addressMode === 2){
            if(!mccaData?.city || mccaData?.city?.length < 3){
                refState.current.show("Не указан город", true, 4000)
                return
            }
        }


        mccaRunData.current = {
            city: mccaData?.city ? mccaData?.city : undefined,
            address: mccaData?.address ? mccaData?.address : undefined,
            orderId: orderId,
            addressMode: addressMode,
            mode: 0,
            login: mccaData?.login,
            tarifId: xTarif,
            flexList: x,
            gender: gender,
            noContact: noContact

        }


        exMccaRun().then((e)=>{
            if(e?.success){
                if(refState?.current)refState.current.show("Задача запущена" , false, 0)
                return
            }
            if(refState?.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" , true, 0)

        })



    }


    const buildNoContact = ()=>{
        return (
            <div className={styles.ncCont}>
                <div className={styles.adLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={noContact} onChange={()=>setNoContact(! noContact)}/>
                    <div className={styles.adTitle}>Не использовать контакный номер</div>
                </div>
            </div>
        )
    }


    const buildAddressItem = ()=>{

        return(
            <div className={styles.adCont}>
                <div className={styles.adLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={addressMode === 0} onChange={()=>setAddressMode(0)}/>
                    <div className={styles.adTitle}>Адрес из заказа</div>
                </div>

                <div className={styles.adLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={addressMode === 1} onChange={()=>setAddressMode(1)}/>
                    <div className={styles.adTitle}>Адрес</div>
                    <input className={["form-control form-control-sm"].join(' ')} type={"text"} value={mccaData?.address ? mccaData?.address : ""}
                           onChange={(e)=>{
                               setMccaData({...mccaData, address: e?.target?.value})
                           }}
                           onClick={()=>setAddressMode(1)}
                    />
                </div>

                <div className={styles.adLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={addressMode === 2} onChange={()=>setAddressMode(2)}/>
                    <div className={styles.adTitle}>Сгенерировать из города</div>
                    <input  className={["form-control form-control-sm"].join(' ')} type={"text"} value={mccaData?.city ? mccaData?.city : ""}
                        onChange={(e)=>{

                            setMccaData({...mccaData, city: e?.target?.value})
                        }}
                            onClick={()=>setAddressMode(2)}
                    />
                </div>


            </div>

        )
    }


    return (
        <ModalWindow>
            <MainFormTemplate title={`MCCA [ ${orderId} ] Номер [ ${ctn} ] Временный [ ${tmpCtn} ]`} maxWidth={"1200px"} background={"white"} load={ldrFlexList || ldrMccaRun}>
                <div className={"row align-items-center justify-content-center d-flex"}>
                    <div className={"col-lg-4 col-xl-5 col-md-12"}>
                        <InputItem
                            val={mccaData?.login}
                            mode={"ie"}
                            info={"Логин"}
                            title={"Логин"}
                            titleShift={0}
                            regExp={/^[a-z0-9_]{5,30}$/ui}
                            onChange={(e)=>{
                                setMccaData({...mccaData, login: e?.toString().trim()})
                            }}
                        ></InputItem>
                    </div>
                </div>


                <div className={styles.lineCont}>
                    <div className={styles.lineTitle}>Набор</div>
                    <div className={"row"}>
                        {buildBundle()}
                    </div>
                </div>


                {false &&
                    <>
                        <div className={styles.lineCont}>
                            <div className={styles.lineTitle}>Тариф</div>
                            <div className={"row"}>
                                {buildTarif()}
                            </div>
                        </div>


                        <div className={styles.lineCont}>
                            <div className={styles.lineTitle}>Аб.плата</div>
                            <div className={"row"}>
                                {buildAp()}
                            </div>
                        </div>

                        <div className={styles.lineCont}>
                            <div className={styles.lineTitle}>Пакет</div>
                            <div className={"row"}>
                                {buildPacket()}
                            </div>
                        </div>

                        <div className={styles.lineCont}>

                            <div className={styles.lineTitle}>SMS</div>
                            <div className={"row"}>
                                {buildSms()}
                            </div>
                        </div>


                        <div className={styles.lineCont}>
                            <div className={styles.lineTitle}>Интернет</div>
                            <div className={"row"}>
                                {buildNet()}
                            </div>
                        </div>
                    </>

                }


                <div className={"row "}>
                    {buildNoContact()}
                </div>

                <div className={"row "}>
                    {buildGenderItem()}
                </div>

                <div className={"row "}>
                    <div className={"d-flex col-12"}>
                        {buildAddressItem()}
                    </div>
                </div>

                <div className={"row my-2"}>
                    <ErrorLineItem ref={refState} height={"30px"}/>
                </div>

                <div className={"row my-2"}>
                    <div className={"d-flex col-12"}>
                        <ButtonContainer clsCont={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={handleMnp}
                                    disabled={ tmpCtn?.length < 10}
                            >MNP</button>

                            <button type="button" className="btn btn-secondary "
                                    onClick={handleNew}
                            >Новый</button>

                            <button type="button" className="btn btn-secondary "
                                    onClick={onClose}
                            >Выход</button>


                        </ButtonContainer>

                    </div>

                </div>


            </MainFormTemplate>
        </ModalWindow>
    )
}